export const tuple = (...args) => args;
const normalSizes = tuple('mini', 'small', 'medium', 'large', 'xlarge');
export const normalColors = tuple('default', 'primary', 'secondary', 'success', 'warning', 'error', 'gradient');
export const simpleColors = tuple('default', 'primary', 'secondary', 'success', 'warning', 'error');
export const extendedColors = tuple('default', 'primary', 'secondary', 'success', 'warning', 'error', 'invert', 'gradient');
export const extraColors = tuple('default', 'primary', 'secondary', 'success', 'warning', 'error', 'dark', 'lite', 'alert', 'purple', 'violet', 'gradient', 'cyan');
export const normalLoaders = tuple('default', 'points', 'points-opacity', 'gradient', 'spinner');
export const normalWeights = tuple('light', 'normal', 'bold');
export const textWeights = tuple(
/* Keyword values */
'normal', 'bold',
/* Keyword values relative to the parent */
'lighter', 'bolder',
/* Global values */
'inherit', 'initial', 'revert', 'unset');
export const textTransforms = tuple(
/* Keyword values */
'none', 'capitalize', 'uppercase', 'lowercase', 'full-width', 'full-size-kana',
/* Global values */
'inherit', 'initial', 'revert', 'unset');
const themeTypes = tuple('dark', 'light');
const copyTypes = tuple('default', 'slient', 'prevent');
const triggerTypes = tuple('hover', 'click');
const placement = tuple('top', 'topStart', 'topEnd', 'left', 'leftStart', 'leftEnd', 'bottom', 'bottomStart', 'bottomEnd', 'right', 'rightStart', 'rightEnd');
const position = tuple('static', 'relative', 'absolute', 'fixed', 'sticky',
/* Global values */
'inherit', 'initial', 'revert', 'unset');
const objectFit = tuple('contain', 'cover', 'fill', 'none', 'scale-down',
/* Global values */
'inherit', 'initial', 'revert', 'unset');
const dividerAlign = tuple('start', 'center', 'end', 'left', 'right');
const justify = tuple('flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly');
const alignItems = tuple('flex-start', 'flex-end', 'center', 'stretch', 'baseline');
const alignContent = tuple('stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around');
const direction = tuple('row', 'row-reverse', 'column', 'column-reverse');
const wrap = tuple('nowrap', 'wrap', 'wrap-reverse');
const display = tuple('flex', 'block', 'grid', 'inline', 'inline-block', 'inline-flex', 'inline-grid');
const contentPosition = tuple('left', 'right');
export const excludedInputPropsForTextarea = tuple('clearable', 'as', 'rounded', 'labelLeft', 'labelRight', 'contentLeft', 'contentRight', 'contentClickable', 'contentLeftStyling', 'contentRightStyling', 'onContentClick', 'onClearClick');